module.exports = __webpack_public_path__ + "static/media/ut.c4944af3.svg";